
import { ref } from "@vue/reactivity";
import { watch, computed} from '@vue/runtime-core';
import {useStore} from "vuex";
import{useMutations} from '@/store/helper'
import Dialog from "primevue/dialog";
import router from '@/router';
import '../../assets/sass/components/DocumentosLegales/_popUpTratamientoDatos.scss';
import { useRoute } from 'vue-router';

export default {
name: 'PopUpTerminosCondiciones',
components: {
    Dialog
},
props: {
    textoPopUpTYC:String,
    siguientePaginaTYC: String,
    nombreBotonConfirmTYC: String,
    paginaOrigen: {
        type: String,
        default: "",
    },
    StoreVacio:Boolean
},
setup(props, {emit}) {     
      const store= useStore();
      const descargando = ref(false);
      const checkTYC= ref(false);
      const errorAPI= ref(false);
      const errorPDF=ref(false);
      const obligatorio= ref(false);
      const procesando=ref(false);
      const{setTyC} = useMutations(['setTyC']);
      const{setAprobacionDocumentosLegales} = useMutations(['setAprobacionDocumentosLegales']);
      const idDocumento = computed(() => store.state.datosTycTtd.find((doc) => doc.nombreDocumento.includes("Terminos y Condiciones"))?.id);  
      const Permiso = localStorage.getItem("Permiso");
      const RedirigirPlanes = computed(() => localStorage.getItem("DatosContactoRedireccion") === "Plans");
      const route = useRoute();
      const sinSalidaDePlans = computed(() => {
        return RedirigirPlanes.value && route.name == 'Plans'
      });

      if(Permiso == "Restringido")
      {
        location.replace(process.env.VUE_APP_Front + "UnAutorized");
      }

    function Validarcheck(){     
          if(checkTYC.value){
            aprobarTYC();
          }else{
            obligatorio.value=true;
            errorAPI.value=false;           
          }
          errorPDF.value=false;       
      }

      watch(()=>checkTYC.value,()=>{
        if(checkTYC.value){
          obligatorio.value=false;
          }else{
            obligatorio.value=true;
            errorAPI.value=false;
          }
          errorPDF.value=false; 
      });

      function aprobarTYC(){
        procesando.value=true;
        errorAPI.value = false;
        errorPDF.value = false;
        var data={
            Identificacion:localStorage.getItem('Identificacion'),
            Tipoidentificacion:localStorage.getItem('TipoIdentificacion'),
            IdDocumentoParaAprobar:idDocumento.value     
         }  
         setTyC(data);
          store.dispatch('AprobarTyC',localStorage.getItem('Tokensin')).then(()=>{
            errorAPI.value=false;    
            errorPDF.value=false;       
            setAprobacionDocumentosLegales({id: idDocumento.value, aprobo: true});
            redirigirContinuar();
          }).catch(error=>{
              console.log(error);
              errorAPI.value=true;
              errorPDF.value=false;
              descargando.value = false;
              procesando.value = false; 
          });     
        }

      function obtenerTYC()
      {
        descargando.value = true;
        errorPDF.value = false;
        obligatorio.value = false;
        errorAPI.value = false;
        let params = {
             id: idDocumento.value,
             nombreArchivo: "Terminos y Condiciones"
          };
      store.dispatch("obtenerDocumentosLegales",params)
        .then(() => {
          descargando.value = false;
        })
        .catch((error) => {
          console.log(error);
          descargando.value = false; 
          errorPDF.value = true;
        });
      };

      function redirigirContinuar()
      {
        if(["Plans", "DetalleTransmision", "QualificationDelcop"].includes(props.paginaOrigen))
        {
            emit('cerrarPopUpTYC');
        }     
        else
        {
            router.push({ name: props.siguientePaginaTYC })
        }      
      }

      function redirigirTransmision()
      {
        if(props.siguientePaginaTYC == "LoadFile")
        {
          emit('cerrarPopUpTYC');
          return;
        }

        const ruta = RedirigirPlanes.value ? { name: "Plans"} : { name: "Transmission"};
        router.push(ruta);             
      }

    return {
      store,
      descargando,
      checkTYC,
      obtenerTYC,
      errorAPI,
      obligatorio,
      errorPDF,
      procesando,
      Validarcheck,
      idDocumento,
      redirigirTransmision,
      RedirigirPlanes,
      sinSalidaDePlans
    };
  }
};
